<template>
  <svg
    v-if="size === '48'"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="47"
      height="47"
      rx="7.5"
      fill="white"
      stroke="#211A1E"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.1938 16.8317C19.5958 16.1012 20.033 15.6128 20.6819 15.3546C21.8709 14.8818 26.1293 14.8818 27.3174 15.3547C27.9659 15.6128 28.4033 16.101 28.8055 16.8314L29.2578 17.6986C29.2681 17.7158 29.2776 17.7309 29.2862 17.7439L29.3246 17.7964C29.5306 18.0209 29.8754 18.1565 30.103 18.1565C32.255 18.1565 34 19.9011 34 22.0525V27.8475C34 30.5917 31.7742 32.8175 29.03 32.8175H18.97C16.2251 32.8175 14 30.592 14 27.8475V22.0525C14 19.9011 15.745 18.1565 17.897 18.1565C18.1238 18.1565 18.4691 18.0207 18.6754 17.7964C18.6796 17.7919 18.6849 17.7852 18.6914 17.7763L18.7429 17.6975L19.1938 16.8317ZM27.4917 17.5551C27.2417 17.1012 27.0158 16.8491 26.7626 16.7483L26.6433 16.7087C25.6142 16.4178 22.0344 16.431 21.2364 16.7483C20.9833 16.849 20.7577 17.1011 20.508 17.5548L20.1232 18.2989L20.0284 18.4703C19.9494 18.6019 19.8703 18.7129 19.7799 18.8113C19.2735 19.3618 18.5242 19.6565 17.897 19.6565L17.7329 19.662C16.4858 19.7464 15.5 20.7847 15.5 22.0525V27.8475C15.5 29.7637 17.0536 31.3175 18.97 31.3175H29.03C30.9458 31.3175 32.5 29.7633 32.5 27.8475V22.0525C32.5 20.7296 31.4267 19.6565 30.103 19.6565L29.9289 19.6492C29.3403 19.6008 28.6793 19.3117 28.2194 18.8106C28.1303 18.7135 28.0517 18.6033 27.9731 18.4729C27.9618 18.4542 27.9478 18.4295 27.9317 18.4004L27.8156 18.1826L27.4917 17.5551ZM29.5041 20.5C30.0564 20.5 30.5041 20.9477 30.5041 21.5C30.5041 22.0128 30.1181 22.4355 29.6207 22.4933L29.5041 22.5C28.9428 22.5 28.4951 22.0523 28.4951 21.5C28.4951 20.9872 28.8812 20.5645 29.3785 20.5067L29.5041 20.5ZM24.0003 21.1992C21.8301 21.1992 20.0713 22.958 20.0713 25.1282C20.0713 27.2984 21.8301 29.0572 24.0003 29.0572C26.1705 29.0572 27.9293 27.2984 27.9293 25.1282C27.9293 22.958 26.1705 21.1992 24.0003 21.1992ZM24.0003 22.6992C25.3421 22.6992 26.4293 23.7864 26.4293 25.1282C26.4293 26.47 25.3421 27.5572 24.0003 27.5572C22.6585 27.5572 21.5713 26.47 21.5713 25.1282C21.5713 23.7864 22.6585 22.6992 24.0003 22.6992Z"
      fill="#211A1E"
    />
    <path
      d="M33.074 17.16H31.506V14.682H29V13.38H31.506V11H33.074V13.38H35.58V14.682H33.074V17.16Z"
      fill="black"
    />
  </svg>
  <svg
    v-else
    width="62"
    height="61"
    viewBox="0 0 62 61"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1.32812"
      y="0.870117"
      width="59.6024"
      height="59.6289"
      rx="7.5"
      fill="white"
      stroke="#211A1E"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M25.0575 21.6276C25.5649 20.7049 26.117 20.088 26.9362 19.7618C28.4374 19.1647 33.8138 19.1647 35.3138 19.7619C36.1326 20.088 36.6848 20.7047 37.1927 21.6272L37.7637 22.7225C37.7767 22.7442 37.7887 22.7633 37.7995 22.7797L37.848 22.8461C38.1081 23.1296 38.5435 23.3009 38.8308 23.3009C41.5479 23.3009 43.751 25.5045 43.751 28.222V35.5417C43.751 39.0079 40.9408 41.8193 37.4761 41.8193H24.7749C21.3093 41.8193 18.5 39.0083 18.5 35.5417V28.222C18.5 25.5045 20.7031 23.3009 23.4202 23.3009C23.7065 23.3009 24.1424 23.1294 24.403 22.8461C24.4082 22.8404 24.415 22.8319 24.4232 22.8208L24.4881 22.7211L25.0575 21.6276ZM35.5339 22.5413C35.2183 21.968 34.9331 21.6496 34.6135 21.5223L34.4628 21.4722C33.1635 21.1048 28.6438 21.1215 27.6363 21.5223C27.3168 21.6495 27.0319 21.9678 26.7167 22.5409L26.2308 23.4808L26.1112 23.6973C26.0114 23.8635 25.9115 24.0037 25.7975 24.128C25.158 24.8234 24.2121 25.1956 23.4202 25.1956L23.213 25.2026C21.6384 25.3091 20.3938 26.6207 20.3938 28.222V35.5417C20.3938 37.962 22.3553 39.9246 24.7749 39.9246H37.4761C39.8949 39.9246 41.8572 37.9615 41.8572 35.5417V28.222C41.8572 26.551 40.502 25.1956 38.8308 25.1956L38.611 25.1864C37.8679 25.1252 37.0333 24.76 36.4527 24.1272C36.3402 24.0045 36.2409 23.8653 36.1417 23.7006C36.1274 23.6769 36.1097 23.6458 36.0894 23.609L35.9428 23.334L35.5339 22.5413ZM38.0747 26.261C38.772 26.261 39.3373 26.8265 39.3373 27.5241C39.3373 28.1719 38.8499 28.7058 38.222 28.7787L38.0747 28.7872C37.3661 28.7872 36.8008 28.2217 36.8008 27.5241C36.8008 26.8764 37.2882 26.3425 37.9161 26.2695L38.0747 26.261ZM31.1259 27.1442C28.3859 27.1442 26.1653 29.3657 26.1653 32.1069C26.1653 34.8481 28.3859 37.0697 31.1259 37.0697C33.8659 37.0697 36.0864 34.8481 36.0864 32.1069C36.0864 29.3657 33.8659 27.1442 31.1259 27.1442ZM31.1259 29.0389C32.8199 29.0389 34.1926 30.4121 34.1926 32.1069C34.1926 33.8018 32.8199 35.175 31.1259 35.175C29.4318 35.175 28.0591 33.8018 28.0591 32.1069C28.0591 30.4121 29.4318 29.0389 31.1259 29.0389Z"
      fill="#211A1E"
    />
    <path
      d="M42.587 22.0419H40.6073V18.912H37.4434V17.2674H40.6073V14.2612H42.587V17.2674H45.7509V18.912H42.587V22.0419Z"
      fill="black"
    />
  </svg>
</template>

<script>
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  props: {
    size: {
      type: Boolean,
      default: false,
    },
  },
});
</script>
